var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "panel-body" }, [
      _c(
        "div",
        { staticClass: "report-content" },
        [
          _vm.loading
            ? _c("span", { staticClass: "error loading status_padding" }, [
                _c("i", {
                  staticClass: "fa fa-spinner fa-pulse",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" Загрузка\n        данных...\n      "),
              ])
            : _vm.error
            ? _c("span", { staticClass: "error status_padding" }, [
                _c("i", {
                  staticClass: "fa fa-exclamation-triangle",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" Ошибка\n        загрузки данных\n      "),
              ])
            : _vm.isStatsEmpty
            ? _c("span", [
                _c("p", { staticClass: "error" }, [
                  _vm._v("Нет данных для статистики"),
                ]),
              ])
            : _c("GChart", {
                attrs: {
                  type: "ColumnChart",
                  data: _vm.chartData,
                  options: _vm.chartOptions,
                },
              }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h3", { staticClass: "panel-title text-center" }, [
        _vm._v("\n      Статистика посещения системы учащимися\n    "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }